module.exports = __webpack_public_path__ + "static/media/woo2.3c385d19.png";